import * as React from "react";
import { List, Box, Alert, Button } from "@mui/material";
import LoadingView from "../../components/LoadingView";
import { useMarcature } from "../../service/marcature";
import ItemMarcatura from "./ItemMarcatura";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Marcature = ({

  idoperatorecantiere = null

} : {

  idoperatorecantiere? : string | null

}) => {

  const { state } : { state : any } = useLocation();

  const navigate = useNavigate(); 

  const marcature = useMarcature({

    idoperatorecantiere: idoperatorecantiere ? idoperatorecantiere : state.idoperatorecantiere, 
    idcantiere: state.idcantiere, 
    datada: state.datada, 
    dataa: state.dataa

  }); 

  return (
    <Box>
    {marcature.isLoading === true ? (
      
      <LoadingView />

    ) : (

      <Box>
        <Button onClick={() => {

          navigate(-1); 

        }} variant="contained" sx={{mb:2}} startIcon={<ArrowBackIcon />}>Torna indietro</Button>
        <List sx={{ width: "100%", bgcolor: "background.paper" }}>
        {marcature.results && marcature.results.length > 0 ? (

          marcature.results.map((result, key) => (
            <ItemMarcatura key={key} marcatura={result} />
          ))

        ) : (

          <Box>
            <Alert severity="info">Nessuna marcatura da mostrare</Alert>
          </Box>

        )}
        </List>
      </Box>

    )}
    </Box>
  );
};

export default Marcature;
